export default "__VITE_ASSET__DibVPc9b__"